class IUGU {
  convertStatus(status) {
    switch (status) {
      case 'pending':
        return 'pendente';
      case 'paid':
        return 'paga';
      case 'canceled':
        return 'cancelada';
      case 'draft':
        return 'rascunho';
      case 'partially_paid':
        return 'parcialmente paga';
      case 'refunded':
        return 'reembolsada';
      default:
        return '';
    }
  }

  convertPayment(payment) {
    switch (payment) {
      case 'credit card':
        return 'Cartão de Crédito';
      case 'credit_card':
        return 'Cartão de Crédito';
      case 'bank_slip':
        return 'Boleto Bancário';
      case 'bank slip':
        return 'Boleto Bancário';
      default:
        return payment;
    }
  }
}

export default new IUGU();
